import {
  ADDSPEND,
  ADDSPEND_FAILED,
  ADDSPEND_SUCCESS,
  DELETESPEND,
  DELETESPEND_FAILED,
  DELETESPEND_SUCCESS,
  SPEND,
  SPENDSLIST,
  SPENDSLIST_FAILED,
  SPENDSLIST_SUCCESS,
  SPENDTRANSACTIONLIST,
  SPENDTRANSACTIONLIST_FAILED,
  SPENDTRANSACTIONLIST_SUCCESS,
  SPEND_FAILED,
  SPEND_SUCCESS,
  UPDATESPEND,
  UPDATESPEND_FAILED,
  UPDATESPEND_SUCCESS,
} from "./actionType";

let initialState = {
  spendList: [],
  amountList: [],
  spendTransactions: [],
  spend: {},
  loading: false,
  success: false,
  error: "",
};

export const spendReducer = (state = initialState, action) => {
  switch (action.type) {
    case SPENDSLIST:
      return {
        ...state,
        spendList: [],
        loading: true,
        success: false,
        error: "",
      };
    case SPENDSLIST_SUCCESS:
      return {
        ...state,
        spendList: action.payload,
        loading: false,
        success: true,
        error: "",
      };
    case SPENDSLIST_FAILED:
      return {
        ...state,
        spendList: [],
        loading: false,
        success: false,
        error: action.payload,
      };
    case SPENDTRANSACTIONLIST:
      return {
        ...state,
        spendTransactions: [],
        loading: true,
        success: false,
        error: "",
      };
    case SPENDTRANSACTIONLIST_SUCCESS:
      return {
        ...state,
        spendTransactions: action.payload,
        loading: false,
        success: true,
        error: "",
      };
    case SPENDTRANSACTIONLIST_FAILED:
      return {
        ...state,
        spendTransactions: [],
        loading: false,
        success: false,
        error: action.payload,
      };
    case SPEND:
      return {
        ...state,
        spend: {},
        loading: true,
        success: false,
        error: "",
      };
    case SPEND_SUCCESS:
      return {
        ...state,
        spend: action.payload,
        loading: false,
        success: true,
        error: "",
      };
    case SPEND_FAILED:
      return {
        ...state,
        spend: {},
        loading: false,
        success: false,
        error: action.payload,
      };
    case ADDSPEND:
      return {
        ...state,
        loading: true,
        success: false,
        error: "",
      };
    case ADDSPEND_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: "",
      };
    case ADDSPEND_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case UPDATESPEND:
      return {
        ...state,
        loading: true,
        success: false,
        error: "",
      };
    case UPDATESPEND_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: "",
      };
    case UPDATESPEND_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case DELETESPEND:
      return {
        ...state,
        loading: true,
        success: false,
        error: "",
      };
    case DELETESPEND_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: "",
      };
    case DELETESPEND_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
